import infoIcon from '@xero/xui-icon/icons/info';
import XUIIcon from '@xero/xui/react/components/icon/XUIIcon';
import { XUIContentBlock, XUIContentBlockItem } from '@xero/xui/react/contentblock';
import React, { FC } from 'react';
import "./index.css"

export interface ITaxDisclaimerProps {
    blurb: string | React.ReactNode
    showIcon: boolean;
}

const TaxDisclaimer: FC<ITaxDisclaimerProps> =
    ({
        blurb,
        showIcon,
    }) => {
        const icon = showIcon ? <XUIIcon icon={infoIcon} size='large' color='black-faint' /> : null
        const description = <span className="xui-text-minor">{blurb}</span>

        return (
            <XUIContentBlock className="xui-panel overview" data-automationid='tax-disclaimer'>
                <XUIContentBlockItem
                    description={description}
                    leftContent={icon}
                />
            </XUIContentBlock>
        );
    };

export default TaxDisclaimer;




